module.exports = __webpack_public_path__ + "static/media/buildingConstruction28.263e977d.jpg";